import React from "react";
import { useNavigate } from "react-router-dom";
import { Flame, LogOut } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Header() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header
      data-testid="app-header"
      className="bg-slate-950 text-white border-b border-slate-800 sticky top-0 z-50 px-6 py-4 flex justify-between items-center"
    >
      <button
        data-testid="logo-home-btn"
        onClick={() => navigate("/")}
        className="flex items-center gap-3 group"
      >
        <span className="grid place-items-center w-9 h-9 bg-[#E50000] text-white">
          <Flame size={20} strokeWidth={2} />
        </span>
        <div className="text-left leading-none">
          <div className="font-display font-black tracking-tighter text-lg">SPRINKLER TAKEOFF</div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-slate-400 mt-0.5">
            Fire Protection Estimating
          </div>
        </div>
      </button>

      {user && (
        <div className="flex items-center gap-5">
          <span data-testid="user-email" className="text-sm text-slate-300 hidden sm:inline">
            {user.email}
          </span>
          <button
            data-testid="logout-btn"
            onClick={async () => {
              await logout();
              navigate("/login");
            }}
            className="flex items-center gap-2 text-sm font-semibold text-slate-300 hover:text-white transition-colors"
          >
            <LogOut size={16} /> Sign out
          </button>
        </div>
      )}
    </header>
  );
}
